import { Col, Row } from 'antd';
import {
  CustomButton,
  CustomTable,
  CustomText,
  FormInput,
} from '../../../../../components';
import { useEffect, useState } from 'react';
import { GoodTypes } from '../../../types';

const GestorTableItems = ({
  detailData,
  setModalManageAll,
  columnsFijos,
  columnsBienes,
  isRoleManage,
  isRequestedItems,
  onSelectedRowsChange,
}: any) => {
  const [filtered, setFiltered] = useState('');
  const [filteredItems, setFilteredItems] = useState<any>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);

  const filterItems = async(e: any) => {
    const filterValue = e.target.value.toLowerCase();
    setFiltered(filterValue);
    const items = await detailData?.items || [];

    const filter = items?.filter((it: any) => {
      if (!filterValue) return true;
    
      if (detailData?.goods_type === GoodTypes.ACTIVO_FIJO) {
        const plateCode = it.plate_code?.toLowerCase();
        const filter = filterValue.toLowerCase();

        if (plateCode) {
          return plateCode.includes(filter);
        }

        const articleCode = it.item?.code?.toLowerCase() || '';
        const articleName = it.item?.name?.toLowerCase() || '';
        const article = `${articleCode} - ${articleName}`;

        return article.includes(filter);
      }
      return it?.product_code?.toLowerCase()?.includes(filterValue);
    });
  
    setFilteredItems(filter);
  };
  
  const handleModalSomeItemsOpen = () => {
    setModalManageAll(true);
    if (onSelectedRowsChange) {
      onSelectedRowsChange(selectedRowKeys);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys: React.Key[]) => {
      setSelectedRowKeys(selectedKeys);
      if (onSelectedRowsChange) {
        onSelectedRowsChange(selectedKeys);
      }
    },
    getCheckboxProps: (record: any) => ({
      disabled: [14].includes(record.status_id)
    }),
  };

  useEffect(() => {
    setFilteredItems(detailData?.items || []);
  }, [detailData]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={12}>
        <CustomText
            strong={true}
            fontSize="big"
            text={`Listado solicitudes de ${(detailData?.goods_type == 'Activo fijo') ? 'activos' : 'bienes' }`}
          />
        </Col>
        <Col span={12}>
          <FormInput
            label="Buscador"
            name="seuscador"
            placeholder="Buscador por items en el listado"
            value={filtered}
            onChange={(e) => filterItems(e)}
          />
           {isRoleManage && <span style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
            <CustomButton
              style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
              label="Gestionar selección"
              onClick={() => handleModalSomeItemsOpen()}
              size="middle"
              disabled={selectedRowKeys.length === 0}
            />
            </span>}
        </Col>
      </Row>

      {detailData?.goods_type === GoodTypes.ACTIVO_FIJO ? (
        <Row>
          <Col xs={24}>
            <CustomTable
              columns={columnsFijos as any}
              dataSource={filteredItems}
              scroll={{ x: 'max-content' }}
              rowKey="id"
              rowSelection={(detailData?.can_manage_user && !isRequestedItems) ? rowSelection : undefined}
            />
          </Col>
        </Row>
      ) : (
        <Row>
          <Col xs={24}>
            <CustomTable
              columns={columnsBienes as any}
              dataSource={filteredItems}
              scroll={{ x: 'max-content' }}
              rowKey="id" 
              rowSelection={(detailData?.can_manage_user && !isRequestedItems) ? rowSelection : undefined}
            />
          </Col>
        </Row>
      )}
    </>
  );
};

export default GestorTableItems;
